import {Router} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {UserService} from '../service/user.service';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {ApplicationStatus} from '../model/application-status.model';
import {AnalyticsTracker} from '../utils/AnalyticsTracker';
import {UserInteractor} from '../interactors/user.interactor';
import {DocumentType} from '../model/document-type.model';
import {executeWithLoader, LoaderStatus} from '../utils/loader.util';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-lenderpersonalinfo',
    templateUrl: './lenderpersonalinfo.component.html',
    styleUrls: ['./lenderpersonalinfo.component.css'],
    providers: [ApiServiceService, UserService]
})
export class LenderpersonalinfoComponent implements OnInit {

    maxDate = new Date(new Date().getFullYear() - 18, new Date().getMonth(), new Date().getDate());
    minDate = new Date(new Date().getFullYear() - 200, new Date().getMonth(), new Date().getDate());

    public genders: any = [
        {value: 'Male', display: 'Male', id: 'r1'},
        {value: 'Female', display: 'Female', id: 'r2'},
        {value: 'Other', display: 'Other', id: 'r3'}
    ];

    genderdetail: any;
    genderError=false;
    result: any;
    result2: any;
    address: any;
    city: any;
    state: any;
    pincode_num: any;
    dob: any;
    dateError = false;
    lender_application_complete: number;
    cities: any;
    states: any;
    cityError = false;
    stateError = false;
    pincodeError = false;
    dobDisabled = false;
    pinDisabled = false;
    addrDisabled = false;
    cityDisabled = false;
    stateDisabled = false;
    isLoanApplicationSubmitted: boolean;
    userInteractor: UserInteractor;
    profileUpdatedAt: any;
    loaderStatus = new LoaderStatus();

    constructor(private http: HttpClient, private router: Router, private ref: ApiServiceService,
                private userService: UserService, private storageService: StorageService, public analyticsTracker: AnalyticsTracker) {
    }

    onChangeGender(value) {

        this.genderError=false;
        if (value == 'Male') {
            this.genderdetail = 'Male';
        } else if (value == 'Female') {
            this.genderdetail = 'Female';
        } else {
            this.genderdetail = 'Other';
        }
    }

    oncityInput(event) {
        this.city = event.target.value.replace(/[^A-Za-z]+/, '');
    }

    onPinInput(event) {
        this.pincode_num = event.target.value.replace(/[^0-9]+/, '');
    }

    async submitPersonalInfo(): Promise<boolean> {
        return await executeWithLoader(this.loaderStatus, async () => {
            this.dateError = false;
            this.cityError = false;
            this.stateError = false;
            this.pincodeError = false;
            this.genderError=false;
            if (this.genderdetail == undefined || this.genderdetail == null || this.genderdetail  == '') {
                this.genderError = true;
                return false;
            }

            if (new Date(this.dob) <= this.maxDate && new Date(this.dob) >= this.minDate) {
                if (this.dobDisabled == true && this.pinDisabled == true &&
                    this.addrDisabled == true && this.cityDisabled == true &&
                    this.stateDisabled == true) {
                    this.result = (await this.http.post<any>(this.ref.baseURL() + 'addLenderPersonalInfo', {
                        lender_id: this.storageService.getItem(Keys.LENDER_ID),
                        profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                        profileUpdatedAt: this.profileUpdatedAt,
                        lender_application_complete: this.lender_application_complete,
                        gender: this.genderdetail,
                        dob: this.dob,
                        address: this.address,
                        city: this.city,
                        state: this.state,
                        pincode: this.pincode_num,
                        token: this.storageService.getItem(Keys.TOKEN)
                    }).toPromise());

                    if (this.result.status == 'success') {
                        this.storageService.saveItem(Keys.PERSONAL_INFO, 'true');
                        await this.router.navigate(['/invest/residence-info']);
                    }
                } else if (this.dob == undefined || this.dob == null || this.dob == '') {
                    this.dateError = true;
                    return false;
                } else if (this.city == undefined || this.city == null || this.city == '') {
                    this.cityError = true;
                    return false;
                } else if (this.state == undefined || this.state == null || this.state == '') {
                    this.stateError = true;
                    return false;
                } else if (this.pincode_num == undefined || this.pincode_num == null || this.pincode_num == '') {
                    this.pincodeError = true;
                    return false;
                } else {
                    this.result = await this.http.post<any>(this.ref.baseURL() + 'addLenderPersonalInfo', {
                        lender_id: this.storageService.getItem(Keys.LENDER_ID),
                        profile_id: this.storageService.getItem(Keys.PROFILE_ID),
                        lender_application_complete: this.lender_application_complete,
                        gender: this.genderdetail,
                        dob: this.dob,
                        state: this.state,
                        address: this.address,
                        city: this.city,
                        pincode: this.pincode_num,
                        token: this.storageService.getItem(Keys.TOKEN)
                    }).toPromise();
                    if (this.result.status === 'success') {
                        this.storageService.saveItem(Keys.PERSONAL_INFO, 'true');
                        await this.router.navigate(['/invest/residence-info']);
                    }
                }
            } else {
                this.dateError = true;
                return false;
            }
        });
    }

    async ngOnInit() {
        const profileId = this.storageService.getItem(Keys.PROFILE_ID);
        const token = this.storageService.getItem(Keys.TOKEN);

        const settingsResponse: any = await this.http.post<any>(this.ref.baseURL() + 'getAllSettings', {}).toPromise();

        if (settingsResponse.status == 'success') {
            this.cities = settingsResponse.result.city;
            this.states = settingsResponse.result.state_list;
        }

        this.genderdetail = 'Male';

        const response: any = await this.http.post<any>(this.ref.baseURL() + 'getLenderInfoDetails',
            {
                lender_id: this.storageService.getItem(Keys.LENDER_ID),
                profile_id: profileId,
                token: token
            }).toPromise();

        const lenderDetails = response.lender_info;
        this.lender_application_complete = lenderDetails.lender_application_complete;

        if (lenderDetails.correspondence_address) {
            if (this.aadhaarNumberExists(lenderDetails.correspondence_address)) {
                this.disableAddressFields();
            }
            this.populateAddressFields(lenderDetails.correspondence_address);
        } else {
            this.populateAddressFields(lenderDetails.profile.correspondence_address);
        }

        this.genderdetail = lenderDetails.profile.gender;
        this.dob = lenderDetails.profile.dob;

        this.userService.getUserLenderApplicationStatus(profileId, token)
            .then((response) => {
                this.isLoanApplicationSubmitted = (response.loanDetails.loan_application_status === ApplicationStatus.Submitted);
            })
            .catch(() => {
                console.log('An error occurred while fetching loan and lender application status');
            });
    }

    private populateAddressFields(correspondenceAddress: any) {
        if (correspondenceAddress) {
            this.address = correspondenceAddress.address;
            this.city = correspondenceAddress.city;
            this.state = correspondenceAddress.state;
            this.pincode_num = correspondenceAddress.pin_code;
        }
    }

    private disableAddressFields() {
        this.dobDisabled = true;
        this.pinDisabled = true;
        this.addrDisabled = true;
        this.cityDisabled = true;
        this.stateDisabled = true;
    }

    private aadhaarNumberExists(correspondenceAddress) {
        return correspondenceAddress && correspondenceAddress.proofs && correspondenceAddress.proofs.length > 0 &&
            correspondenceAddress.proofs.proofType === DocumentType.Aadhaar.toString();
    }
}
